import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { LocationLinksLocationsQuery, ProfessionalTypeEnum } from '@gql/graphql';

export const LOCATION_LINKS_LOCATIONS = graphql(`
  query LocationLinksLocations($country: CountryCode!, $proType: ProfessionalTypeEnum!) {
    professionalLocations(country: $country, proType: $proType) {
      city
      region
    }
  }
`);

export const useLocations = (proType: ProfessionalTypeEnum) => {
  const { countryCode } = useRouter();

  const { data, error, loading } = useQuery<LocationLinksLocationsQuery>(LOCATION_LINKS_LOCATIONS, {
    variables: { country: countryCode, proType },
  });

  return {
    locations: data?.professionalLocations ?? [],
    locationsError: error,
    locationsLoading: loading,
  };
};
